// src/pages/imamMahdi/Return.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Return = () => {
  return (
    <>
      <Helmet>
        <title>The Return of Imam Mahdi (ajtf) | Divine Justice & Prophecy</title>
        <meta
          name="description"
          content="Explore the promised return of Imam Mahdi (ajtf) — the awaited savior who will establish global justice, peace, and truth across the world."
        />
        <meta
          property="og:title"
          content="The Return of Imam Mahdi (ajtf) | Divine Justice & Prophecy"
        />
        <meta
          property="og:description"
          content="Discover how the return of Imam Mahdi fulfills divine justice and unites Abrahamic faiths in hope for a world of peace and compassion."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/wp-content/uploads/2025/08/third-His-role-as-the-ultimate-reformer-.png"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">The Return of Imam Mahdi (aj)</h1>

          <div className="content-section">
            <img
              src="https://ziyaratguide.com/wp-content/uploads/2025/08/third-His-role-as-the-ultimate-reformer-.png"
              alt="His Role as the Ultimate Reformer"
              className="imam-image"
            />

            <h2>A Divine Promise of Justice</h2>
            <p>
              At the heart of Islam – and indeed all Abrahamic faiths – is the conviction that oppression and tyranny will never have the final word. God promises in the Qur’an and through His prophets that truth will ultimately triumph, and the earth will one day be ruled by justice and compassion.
            </p>
            <p>
              For Muslims, this promise finds its ultimate fulfilment in the awaited return of Imam Mahdi (peace be upon him).
            </p>

            <h2>Rooted in the Qur’an</h2>
            <p>
              The Qur’an is filled with assurances that the righteous will inherit the earth and that oppression is only temporary. For example:
            </p>
            <ul>
              <li>
                “And We wished to favour those who were oppressed in the land, and to make them leaders and make them inheritors.” (Qur’an 28:5)
              </li>
              <li>
                “Allah has promised those among you who believe and do righteous deeds that He will surely grant them succession upon the earth…” (Qur’an 24:55)
              </li>
            </ul>

            <h2>His Role as the Ultimate Reformer</h2>
            <p>
              These verses were explained by the Imams of Ahlulbayt (as) to point toward a future when God’s final proof – the Mahdi – would rise to establish a world of equity.
            </p>

            <h2>A Consistent Message Across Abrahamic Traditions</h2>
            <ul>
              <li>
                <strong>Judaism:</strong> Awaits a final anointed king (the Mashiach) who will restore peace and justice.
              </li>
              <li>
                <strong>Christianity:</strong> Looks to the second coming of Jesus (peace be upon him) who will defeat falsehood and establish God’s kingdom.
              </li>
              <li>
                <strong>Islam:</strong> Foretells the appearance of the Mahdi, from the family of the Prophet Muhammad (pbuh), who will prepare the world, joined by Jesus (as) in a final stand against corruption.
              </li>
            </ul>

            <h2>Why Must Imam Mahdi Return?</h2>
            <ul>
              <li>
                <strong>To fulfil divine justice:</strong> The world has seen countless empires built on tyranny. Allah’s promise is that oppression is always short-lived, and the final era belongs to the just.
              </li>
              <li>
                <strong>To realise the purpose of creation:</strong> The ultimate goal is a world where God is worshipped in sincerity, people live in peace, and society mirrors divine compassion.
              </li>
              <li>
                <strong>To answer the cries of the oppressed:</strong> Throughout history, the downtrodden have called upon God for relief. Imam Mahdi’s mission is the promised answer to those cries.
              </li>
            </ul>

            <h2>The Role of Believers</h2>
            <p>
              Awaiting Imam Mahdi is not a passive hope. In Shia tradition, it means:
            </p>
            <ul>
              <li>Aligning ourselves with justice today, so we may stand with him tomorrow.</li>
              <li>
                Cultivating compassion, honesty, and steadfastness, preparing to support his cause.
              </li>
            </ul>
            <blockquote>
              “He who truly awaits our matter is like one who struggles in the path of Allah with his own blood.”
            </blockquote>
            <p>
              The return of Imam Mahdi (aj) is promised as the ultimate fulfilment of God’s pledge that truth will overcome falsehood, and that the earth will be filled with justice after it was filled with tyranny.
            </p>
            <p>
              This hope connects Muslims to the same yearning for a final redeemer found in Judaism and Christianity, reflecting a universal human longing for a world made right.
            </p>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More</h2>
          <ul>
            <li><Link to="/imam-mahdi">Who is Imam Mahdi?</Link></li>
            <li><Link to="/imam-mahdi/described-in-quran-hadith">Described In Quran & Hadith</Link></li>
            <li><Link to="/imam-mahdi/how-to-talk">How To Talk</Link></li>
            <li><Link to="/imam-mahdi/impact-appearance">Impact of His Appearance</Link></li>
            <li><Link to="/imam-mahdi/misconceptions">Misconceptions</Link></li>
            <li><Link to="/imam-mahdi/practices-allegiance">Practices & Allegiance</Link></li>
            <li><Link to="/imam-mahdi/reflections-stories">Reflections & Stories</Link></li>
            <li><Link to="/imam-mahdi/return">Return</Link></li>
            <li><Link to="/imam-mahdi/signs-reappearance">Signs of Reappearance</Link></li>
            <li><Link to="/imam-mahdi/supporters">Supporters</Link></li>
            <li><Link to="/imam-mahdi/ultimate-reformer">The Ultimate Reformer</Link></li>
            <li><Link to="/imam-mahdi/why-occultation">Why Occultation</Link></li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default Return;
